function showConditionText() {
  let cspans = document.querySelectorAll('.cspan');
  let a1 = "<strong>A1 - Brand New:</strong> Unopened or opened with broken seal but visual inspection has confirmed all contents and packaging are in brand new condition (liquidation items, unopened customer returns)";
  let a2 = "<strong>A2 - Brand New, Damaged Packaging:</strong> The product was confirmed to be in brand new condition but exterior packaging is damaged (crush damage, scuffs, broken clamshell, etc.)";
  let mp = "<strong>MP - Missing Parts:</strong> New or nearly new condition but missing parts (water filter with missing cartridge, flashlight with missing battery or cable). Read inspector's note for more details.";
  let de = "<strong>DE - Demo:</strong> Product is in excellent condition but showing some signs of use (footwear worn briefly outside then returned, tent set up outside then returned, packaging may show some damage or stress parts";
  let wd = "<strong>WD - Wear/Damage/Missing Parts:</strong> Product showing obvious signs of use or wear, is missing parts, has damage from customer use or shipping (dents, dings, scratches). Items with this condition are aggressively priced but can still offer some excellent value. Use as spare parts, repair or rebuild or make up a great story to tell your friends about the dent or ding. Read inspector note for more details.";
  cspans.forEach(c => {
    let cond = c.dataset.c;
    let ctip = c.querySelector('.ctip');
    if (cond == 'A1') {
      ctip.innerHTML = a1;    
    } else if (cond == 'A2') {
      ctip.innerHTML = a2; 
    } else if (cond == 'MP') {
      ctip.innerHTML = mp; 
    } else if (cond == 'DE') {
      ctip.innerHTML = de; 
    } else if (cond == 'WD') {
      ctip.innerHTML = wd; 
    } else {
      ctip.remove();
    }
  })
}
showConditionText();

setInterval(showConditionText, 2000);

//let chs = document.querySelectorAll('.card__heading');
//chs.forEach(h => {
//  let sib = h.nextElementSibling
//  h.addEventListener('click', () => {
//    sib.classList.add('show');
//    sib.addEventListener('click', () => {
//      sib.classList.remove('show');
//    })
//  })
// })
// image modal

let pmodal= document.querySelector('.image-modal');
let modalx = document.querySelector('.modal-close')
let pmodalimg = document.querySelector('.image-modal-image');
let pimages = document.querySelectorAll('.card-product-image');
pimages.forEach(x => {
  x.addEventListener('click', () => {
    pmodal.classList.add('showing');
    let xsrc = x.querySelector('img').src;
    pmodalimg.src = xsrc;
  })
})
modalx.addEventListener('click', () => {
  pmodal.classList.remove('showing');
})
